import React from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const PrivateRoute = ({ allowedRoles, children }) => {
  const { user, permissions, loading } = useSelector((state) => state.auth)

  const loginPath = import.meta.env.BASE_URL || '/'

  // loading starts as `true` in the Redux initial state and only becomes
  // false after Firebase auth resolves (FETCH_USER_DETAILS_SUCCESS,
  // FETCH_USER_DETAILS_FAILURE, or RESET_USER). Returning null here keeps
  // the App shell (Header + Sidebar) visible while auth is being resolved,
  // instead of a full-screen Loader that would visually hide them.
  if (loading) {
    return null
  }

  if (!user) {
    return <Navigate to={loginPath} replace />
  }

  if (!permissions || !user?.userType) {
    return null
  }

  // Check if the user has the required permission by checking their roles
  if (permissions && !allowedRoles.some((role) => permissions.includes(role))) {
    return <Navigate to="/unauthorized" />
  }

  return children
}

PrivateRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
}

export default PrivateRoute
